import React from "react";
import CYLINDER_STATE from "shared/consts/cylinder";
import CylinderIcon from 'app/ui/pages/monitor/monitorTableBody/monitorTableRow/cylinderIcons/cylinderIcon/CylinderIcon';
import NumberBadge from "app/ui/commons/numberBadge/NumberBadge";
import _ from "lodash";
import styles from "./CylinderGroupByStatus.module.scss";

const CylinderGroupByStatus = ({
  ghostCylinders,
  commonCylinders,
  cylinderSize,
  inAlert,
}) => {

  const groupByGhostStatus = (array) =>
    array.reduce((acc, item) => {
      const state = item.ghostState;
      if (_.isNil(acc[state])) acc[state] = [];
      acc[state].push(item);
      return acc;
    }, {});

  const groupByStatus = (array) =>
    array.reduce((acc, item) => {
      const state = item.state;
      if (_.isNil(acc[state])) acc[state] = [];
      acc[state].push(item);
      return acc;
    }, {});

  const groupedGhost = groupByGhostStatus(ghostCylinders || []);
  const groupedCommon = groupByStatus(commonCylinders || []);

  const {
    REQUESTED,
    PENDING,
    FULL,
    CURRENT: CURRENT_COMMON,
    EMPTY: EMPTY_COMMON,
  } = CYLINDER_STATE.CYLINDER_STATE;

  const {
    CURRENT: CURRENT_GHOST,
    EMPTY: EMPTY_GHOST,
    FINISHED,
  } = CYLINDER_STATE.GHOST_CYLINDER_STATE;

  const stateOrderGhost = [CURRENT_GHOST, EMPTY_GHOST, FINISHED];

  const stateOrderCommon = [
    REQUESTED,
    PENDING,
    FULL,
    CURRENT_COMMON,
    EMPTY_COMMON,
  ];

  const renderGroup = (grouped, stateOrder, cylinderMode) =>
    stateOrder
      .filter((state) => grouped[state] && grouped[state].length > 0)
      .map((state, index) => {
        const stateCylinders = grouped[state];
        const firstCylinder = stateCylinders[0];

        return (
          <React.Fragment key={firstCylinder.id || index}>
            <CylinderIcon
              state={firstCylinder.state}
              pressure={firstCylinder.pressure}
              inAlert={inAlert}
              cylinderSize={cylinderSize}
              ghostState={firstCylinder.ghostState}
              cylinderMode={cylinderMode}
            />
            <div className={styles.badgeWrapper}>
              <NumberBadge
                number={stateCylinders.length}
                style={{ marginLeft: -20, zIndex: 999 }}
              />
            </div>
          </React.Fragment>
        );
      });

  return [
    ...renderGroup(groupedGhost, stateOrderGhost, 'ghost'),
    ...renderGroup(groupedCommon, stateOrderCommon, 'common'),
  ];
};

export default CylinderGroupByStatus;
